/**
 * Detect iOS or mobile Safari - used to skip FCM/notifications (limited support) and avoid blank screen issues.
 */
export function isIOSOrMobileSafari() {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent;
  return (
    /iPad|iPhone|iPod/.test(ua) ||
    (ua.includes('Safari') && !ua.includes('Chrome') && /Mobile/.test(ua)) ||
    // iPadOS 13+ reports desktop Safari UA; detect via platform + touch points
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
  );
}
